import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Node from '@/glxp/abstract/node'

import GEOM from '@/glxp/geom/plane'
import ShaderManifest from '../shaderManifest'
import { vec3 } from 'gl-matrix'
import Emitter from 'event-emitter'


class Splash extends Rendable {
    constructor(scene) {
        super(scene)

        this.gl = scene.gl
        this.scene = scene

        this.node = new Node()
        this.shader = new Shader(ShaderManifest["sprite"])

        this.hasNormal = false
        this.initBuffer({
            vertices: GEOM.vertices,
            uvs: GEOM.uvs,
            indices: GEOM.indices
        })

        this.initProgram(this.shader.vert, this.shader.frag)
        this.initVao()
        this.initMatrix()
        this.createUniforms()

        this.scale = 1.1
        this.proxies = []

    }

    createUniforms() {
        this.createUniform('uTexture', 'texture')
        this.createUniform('uTime')
        this.createUniform('uSpriteDim')
    }

    applyState() {
        let gl = this.gl

        this.scene.applyDefaultState()

        gl.disable(gl.CULL_FACE)
        // gl.disable(gl.DEPTH_TEST)
        // gl.depthMask(false)
    }

    spawnItem(p) {

        let n = new Node()
        n.position = vec3.clone(p)
        n.position[1] += 0.3
        n.scale = vec3.fromValues(this.scale, this.scale, this.scale)
        n.time = 0
        this.proxies.push(n)

    }

    preRender() {

        for (let i = 0; i < this.proxies.length; i++) {
            const p = this.proxies[i];
            p.time += (this.scene.dt / 1000) * 8        
            if (p.time > 3) {
                this.proxies.splice(i, 1)
            }
        }

    }

    render() {

        this.preRender()

        if (this.proxies.length == 0) {
            return
        }

        let gl = this.gl
        gl.useProgram(this.program)
        gl.bindVertexArray(this.vao)
        this.applyState()

        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture('Splash_Sprite'))
        this.bindUniform('uTexture', 0)

        this.bindUniform('uSpriteDim', 3)
        
        this.bindUniform('uPMatrix', this.scene.camera.getProjectionMatrix())
        this.bindUniform('uVMatrix', this.scene.camera.getViewMatrix())
        for (let i = 0; i < this.proxies.length; i++) {
            const p = this.proxies[i];
            this.bindUniform('uMMatrix', p.getMatrix())
            this.bindUniform('uTime', p.time)
            gl.drawElements(gl.TRIANGLES, GEOM.indices.length, gl.UNSIGNED_SHORT, 0)
        }

        gl.bindVertexArray(null)
    }
}

export default Splash
